<template>
  <div class="notlogin_logisticsInquer">
    <logistics-info :not='true'
                    :wlnum='wlnum'></logistics-info>
  </div>
</template>

<script>
import LogisticsInfo from '@/views/LogisticsInfo.vue'
export default {
  data () {
    return {
      wlnum: ''
    }
  },
  components: {
    LogisticsInfo
  },
  created () {
    this.wlnum = this.$route.query.wlnum
  }
}
</script>

<style>
.notlogin_logisticsInquer {
  width: 100%;
  height: 100vh;
}
</style>